import ApiClient from './apiClient'
import {
  RequestDeleteTaskLabeling,
  RequestDeleteTaskLabelMasterSetting,
  RequestDeleteTaskLabelSettingLabelGroup,
  RequestDeleteTaskManual,
  RequestDeleteTaskPermission,
  RequestDeleteTaskTargetServiceSetting,
  RequestGetTaskExportDetail,
  RequestGetTaskLabeling,
  RequestGetTaskLabelingStatus,
  RequestGetTaskLabelSetting,
  RequestGetTaskLabelSettingDetail,
  RequestGetTaskReportLabelGroup,
  RequestGetTaskReportLabelGroupDetail,
  RequestGetTaskReportLabelGroupDetailMax,
  RequestGetTaskReportLabelGroupDetailSummary,
  RequestGetTaskSearch,
  RequestPostTaskServiceRequest,
  RequestPatchTaskCostSetting,
  RequestPatchTaskLabeling,
  RequestPatchTaskLabelMasterSetting,
  RequestPatchTaskLabelSettingLabelGroup,
  RequestPatchTaskLabelSettingTeamLabelRelation,
  RequestPatchTaskPermission,
  RequestPatchTaskReportLabelGroupDetailSummary,
  RequestPostTaskExportDetail,
  RequestPostTaskLabeling,
  RequestPostTaskLabelMasterSetting,
  RequestPostTaskLabelSettingLabelGroup,
  RequestPostTaskManual,
  RequestPostTaskPermission,
  RequestPostTaskTargetServiceSetting,
  ResponseGetTaskCostSetting,
  ResponseGetTaskExportDetail,
  ResponseGetTaskExportList,
  ResponseGetTaskLabeling,
  ResponseGetTaskLabelingStatus,
  ResponseGetTaskLabelMasterSetting,
  ResponseGetTaskLabelSetting,
  ResponseGetTaskLabelSettingDetail,
  ResponseGetTaskLabelSettingNewDetail,
  ResponseGetTaskPermission,
  ResponseGetTaskReportLabelGroup,
  ResponseGetTaskReportLabelGroupDetail,
  ResponseGetTaskReportLabelGroupDetailMax,
  ResponseGetTaskReportLabelGroupDetailSummary,
  ResponseGetTaskSearch,
  ResponseGetTaskSearchNew,
  ResponseGetTaskTargetServiceSetting,
  ResponsePostTaskLabelMasterSetting,
  ResponsePostTaskLabelSettingLabelGroup,
  ResponsePostTaskManual,
  ResponsePostTaskPermission,
  ResponsePostTaskTargetServiceSetting,
  RequestPostTaskSeparate,
  ResponsePostTaskSeparate,
  RequestDeleteTaskSeparate,
  ResponseDeleteTaskSeparate,
  ResponseGetTaskThresholdSetting,
  RequestPatchTaskThresholdSetting,
  RequestGetTaskReportTeam,
  ResponseGetTaskReportTeam,
  RequestGetTaskReportMember,
  ResponseGetTaskReportMember,
  RequestDeleteTaskProjectTemplateSetting,
  RequestGetTaskProjectTemplateSetting,
  RequestGetTaskProjectTemplateSettingDetail,
  RequestPatchTaskProjectTemplateSetting,
  RequestPostTaskProjectTemplateSetting,
  ResponseGetTaskProjectTemplateSetting,
  ResponseGetTaskProjectTemplateSettingDetail,
  ResponseGetTaskProjectTemplateSettingNewDetail,
  ResponsePostTaskProjectTemplateSetting,
  ResponsePostTaskCostSetting,
  RequestPostTaskCostSetting,
  ResponseGetTaskApprovalGroup,
  RequestPostTaskApprovalGroup,
  ResponsePostTaskApprovalGroup,
  RequestPatchTaskApprovalGroup,
  RequestDeleteTaskApprovalGroup,
  RequestGetTaskApprovalApplication,
  RequestGetTaskApprovalApplicationDetail,
  RequestPostTaskApprovalApplication,
  ResponseGetTaskApprovalApplication,
  ResponseGetTaskApprovalApplicationDetail,
  ResponseDeleteTaskManual,
  ResponseGetTaskExcludeGenerateMemberSetting,
  RequestPostTaskExcludeGenerateMemberSetting,
  RequestDeleteTaskExcludeGenerateMemberSetting,
  RequestDeleteTaskLabelGroupCategory,
  RequestPatchTaskLabelGroupCategory,
  RequestPostTaskLabelGroupCategory,
  ResponseGetTaskLabelGroupCategory,
  ResponsePostTaskLabelGroupCategory,
  RequestGetTaskReportLabelGroupCategory,
  ResponseGetTaskReportLabelGroupCategory,
  RequestGetTaskReportLabelGroupCategoryDetail,
  ResponseGetTaskReportLabelGroupCategoryDetail,
  RequestGetTaskReportLabelGroupCategoryDetailMax,
  ResponseGetTaskReportLabelGroupCategoryDetailMax,
  RequestGetTaskReportLabelGroupCategoryDetailSummary,
  ResponseGetTaskReportLabelGroupCategoryDetailSummary,
  RequestPostTaskLabelGroupImport,
  ResponsePostTaskLabelGroupImport,
  ResponseGetTaskGanttChartList,
  RequestGetTaskGanttChart,
  ResponseGetTaskGanttChart,
  RequestGetTaskGanttChartDetail,
  ResponseGetTaskGanttChartDetail,
  RequestPatchTaskLabel,
  RequestPatchTaskLabelMember,
  ResponseGetTaskOverwriteBreakTimeSetting,
  RequestPatchTaskOverwriteBreakTimeSetting,
  ResponseGetTaskCustomSearchNew,
  RequestGetTaskCustomSearch,
  ResponseGetTaskCustomSearch,
  RequestPostTaskExcludeAutoLabelingTask,
  RequestDeleteTaskExcludeAutoLabelingTask,
  ResponsePostTaskExcludeAutoLabelingTask,
  RequestPostTaskLabelMasterImport,
  ResponsePostTaskLabelMasterImport,
  ResponseGetTaskLabelGroupOrder,
  RequestPatchTaskLabelGroupOrder,
  ResponseGetTaskLearningScopeSetting,
  RequestPatchTaskLearningScopeSetting,
  RequestPatchTaskDisplayCreateManualTaskSetting,
  ResponseGetTaskDisplayCreateManualTaskSetting,
  ResponseGetTaskLabelingTargetModeSetting,
  RequestPatchTaskLabelingTargetModeSetting,
  ResponseGetTaskCompanyServiceName,
  RequestGetTaskCompanyServiceNameEdit,
  ResponseGetTaskCompanyServiceNameEdit,
  RequestPatchTaskCompanyServiceName,
  ResponseGetTaskBulkLabelingNew,
  ResponseGetTaskBulkLabeling,
  RequestGetTaskBulkLabeling,
  RequestPostTaskBulkLabeling,
  RequestDeleteTaskBulkLabeling,
  RequestGetTaskApprovalApplicationList,
  ResponseGetTaskApprovalApplicationList,
  RequestGetTaskNotWorkingRange,
  RequestPatchTaskNotWorkingRange,
  ResponseGetTaskNotWorkingRange,
  RequestGetTaskRecentlyUsedLabelGroup,
  RequestGetTaskSearchLabelGroup,
  ResponseGetTaskRecentlyUsedLabelGroup,
  ResponseGetTaskSearchLabelGroup,
  RequestGetTaskLabelGroupCategoryLabelGroup,
  ResponseGetTaskLabelGroupCategoryLabelGroup,
  RequestGetTaskViewableLabelGroup,
  ResponseGetTaskViewableLabelGroup,
  RequestGetTaskViewableLabelGroupDetail,
  ResponseGetTaskViewableLabelGroupDetail,
  RequestGetTaskViewableLabelGroupMember,
  ResponseGetTaskViewableLabelGroupMember,
  RequestGetTaskViewableLabelGroupTeam,
  ResponseGetTaskViewableLabelGroupTeam,
  RequestGetTaskLabelMasterSetting,
  RequestGetTaskLabelGroupSummary,
  ResponseGetTaskLabelGroupSummary,
} from '../types/task'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabeling = async (params: RequestGetTaskLabeling): Promise<any> => ApiClient.get(
  '/api/task/labeling',
  (result: ResponseGetTaskLabeling) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskLabeling = async (params: RequestPostTaskLabeling): Promise<any> => ApiClient.post(
  '/api/task/labeling',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabeling = async (params: RequestPatchTaskLabeling): Promise<any> => ApiClient.patch(
  '/api/task/labeling',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskLabeling = async (params: RequestDeleteTaskLabeling): Promise<any> => ApiClient.delete(
  '/api/task/labeling',
  () => {
    // do nothing
  },
  { data: params },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskManual = async (params: RequestPostTaskManual): Promise<any> => ApiClient.post(
  '/api/task/manual_tasks',
  (result: ResponsePostTaskManual) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskManual = async (params: RequestDeleteTaskManual): Promise<any> => ApiClient.delete(
  `/api/task/manual_tasks/${params.id}`,
  (result: ResponseDeleteTaskManual) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskTargetServiceSetting = async (): Promise<any> => ApiClient.get(
  '/api/task/target_service_settings',
  (result: ResponseGetTaskTargetServiceSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskTargetServiceSetting = async (params: RequestPostTaskTargetServiceSetting): Promise<any> => ApiClient.post(
  '/api/task/target_service_settings',
  (result: ResponsePostTaskTargetServiceSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskTargetServiceSetting = async (params: RequestDeleteTaskTargetServiceSetting): Promise<any> => ApiClient.delete(
  `/api/task/target_service_settings/${params.id}`,
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelMasterSetting = async (params: RequestGetTaskLabelMasterSetting): Promise<any> => ApiClient.get(
  '/api/task/label_master_settings',
  (result: ResponseGetTaskLabelMasterSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskLabelMasterSetting = async (params: RequestPostTaskLabelMasterSetting): Promise<any> => ApiClient.post(
  '/api/task/label_master_settings',
  (result: ResponsePostTaskLabelMasterSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelMasterSetting = async (params: RequestPatchTaskLabelMasterSetting): Promise<any> => ApiClient.patch(
  `/api/task/label_master_settings/${params.label_master_id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskLabelMasterSetting = async (params: RequestDeleteTaskLabelMasterSetting): Promise<any> => ApiClient.delete(
  `/api/task/label_master_settings/${params.label_master_id}`,
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelSetting = async (params: RequestGetTaskLabelSetting): Promise<any> => ApiClient.get(
  '/api/task/label_groups',
  (result: ResponseGetTaskLabelSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelSettingDetail = async (params: RequestGetTaskLabelSettingDetail): Promise<any> => ApiClient.get(
  `/api/task/label_groups/${params.id}`,
  (result: ResponseGetTaskLabelSettingDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelSettingNewDetail = async (): Promise<any> => ApiClient.get(
  "/api/task/label_groups/new",
  (result: ResponseGetTaskLabelSettingNewDetail) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskLabelSettingLabelGroup = async (params: RequestPostTaskLabelSettingLabelGroup): Promise<any> => ApiClient.post(
  '/api/task/label_groups',
  (result: ResponsePostTaskLabelSettingLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelSettingLabelGroup = async (params: RequestPatchTaskLabelSettingLabelGroup): Promise<any> => ApiClient.patch(
  `/api/task/label_groups/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskLabelSettingLabelGroup = async (params: RequestDeleteTaskLabelSettingLabelGroup): Promise<any> => ApiClient.delete(
  `/api/task/label_groups/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelSettingTeamLabelRelation = async (params: RequestPatchTaskLabelSettingTeamLabelRelation): Promise<any> => ApiClient.patch(
  `/api/task/label_setting/team_label_relation/`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelingStatus = async (params: RequestGetTaskLabelingStatus): Promise<any> => ApiClient.get(
  '/api/task/labeling_status',
  (result: ResponseGetTaskLabelingStatus) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroup = async (params: RequestGetTaskReportLabelGroup): Promise<any> => ApiClient.get(
  '/api/task/report/label_groups',
  (result: ResponseGetTaskReportLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroupDetail = async (params: RequestGetTaskReportLabelGroupDetail): Promise<any> => ApiClient.get(
  `/api/task/report/label_groups/${params.id}`,
  (result: ResponseGetTaskReportLabelGroupDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroupDetailMax = async (params: RequestGetTaskReportLabelGroupDetailMax): Promise<any> => ApiClient.get(
  `/api/task/report/label_groups/${params.label_group_id}/max`,
  (result: ResponseGetTaskReportLabelGroupDetailMax) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroupDetailSummary = async (params: RequestGetTaskReportLabelGroupDetailSummary): Promise<any> => ApiClient.get(
  `/api/task/report/label_groups/${params.label_group_id}/summary`,
  (result: ResponseGetTaskReportLabelGroupDetailSummary) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskReportLabelGroupDetailSummary = async (params: RequestPatchTaskReportLabelGroupDetailSummary): Promise<any> => ApiClient.patch(
  `/api/task/report/label_groups/${params.label_group_id}/summary`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskServiceRequest = async (params: RequestPostTaskServiceRequest): Promise<any> => ApiClient.post(
  '/api/task/service_request',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskExportList = async (): Promise<any> => ApiClient.get(
  '/api/task/exports',
  (result: ResponseGetTaskExportList) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskExportDetail = async (params: RequestGetTaskExportDetail): Promise<any> => ApiClient.get(
  `/api/task/exports/${params.id}`,
  (result: ResponseGetTaskExportDetail) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskExportDetail = async (params: RequestPostTaskExportDetail): Promise<any> => ApiClient.post(
  `/api/task/exports`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskPermission = async (): Promise<any> => ApiClient.get(
  '/api/task/permissions',
  (result: ResponseGetTaskPermission) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskPermission = async (params: RequestPostTaskPermission): Promise<any> => ApiClient.post(
  '/api/task/permissions',
  (result: ResponsePostTaskPermission) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskPermission = async (params: RequestPatchTaskPermission): Promise<any> => ApiClient.patch(
  `/api/task/permissions/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskPermission = async (params: RequestDeleteTaskPermission): Promise<any> => ApiClient.delete(
  `/api/task/permissions/${params.id}`,
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCostSetting = async (): Promise<any> => ApiClient.get(
  '/api/task/cost_settings',
  (result: ResponseGetTaskCostSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskCostSetting = async (params: RequestPostTaskCostSetting): Promise<any> => ApiClient.post(
  '/api/task/cost_settings',
  (result: ResponsePostTaskCostSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskCostSetting = async (params: RequestPatchTaskCostSetting): Promise<any> => ApiClient.patch(
  `/api/task/cost_settings/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskSearchNew = async (): Promise<any> => ApiClient.get(
  "/api/task/search/new",
  (result: ResponseGetTaskSearchNew) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskSearch = async (params: RequestGetTaskSearch): Promise<any> => ApiClient.get(
  "/api/task/search",
  (result: ResponseGetTaskSearch) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskSeparate = async (params: RequestPostTaskSeparate): Promise<any> => ApiClient.post(
  '/api/task/separate_tasks',
  (result: ResponsePostTaskSeparate) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskSeparate = async (params: RequestDeleteTaskSeparate): Promise<any> => ApiClient.delete(
  `/api/task/separate_tasks/${params.id}`,
  (result: ResponseDeleteTaskSeparate) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskThresholdSetting = async (): Promise<any> => ApiClient.get(
  "/api/task/task_threshold_settings",
  (result: ResponseGetTaskThresholdSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskThresholdSetting = async (params: RequestPatchTaskThresholdSetting): Promise<any> => ApiClient.patch(
  "/api/task/task_threshold_settings",
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskDisplayCreateManualTaskSetting = async (): Promise<any> => ApiClient.get(
  "/api/task/task_display_create_manual_task_settings",
  (result: ResponseGetTaskDisplayCreateManualTaskSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const patchTaskDisplayCreateManualTaskSetting = async (params: RequestPatchTaskDisplayCreateManualTaskSetting): Promise<any> => ApiClient.patch(
  "/api/task/task_display_create_manual_task_settings",
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskOverwriteBreakTimeSetting = async (): Promise<any> => ApiClient.get(
  "/api/task/overwrite_break_time_settings",
  (result: ResponseGetTaskOverwriteBreakTimeSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskOverwriteBreakTimeSetting = async (params: RequestPatchTaskOverwriteBreakTimeSetting): Promise<any> => ApiClient.patch(
  "/api/task/overwrite_break_time_settings",
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportMember = async (params: RequestGetTaskReportMember): Promise<any> => ApiClient.get(
  `/api/task/report/members/${params.id}`,
  (result: ResponseGetTaskReportMember) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportTeam = async (params: RequestGetTaskReportTeam): Promise<any> => ApiClient.get(
  `/api/task/report/teams/${params.id}`,
  (result: ResponseGetTaskReportTeam) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskProjectTemplateSetting = async (params: RequestGetTaskProjectTemplateSetting): Promise<any> => ApiClient.get(
  '/api/task/label_group_templates',
  (result: ResponseGetTaskProjectTemplateSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskProjectTemplateSettingDetail = async (params: RequestGetTaskProjectTemplateSettingDetail): Promise<any> => ApiClient.get(
  `/api/task/label_group_templates/${params.id}`,
  (result: ResponseGetTaskProjectTemplateSettingDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskProjectTemplateSettingNewDetail = async (): Promise<any> => ApiClient.get(
  "/api/task/label_group_templates/new",
  (result: ResponseGetTaskProjectTemplateSettingNewDetail) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskProjectTemplateSetting = async (params: RequestPostTaskProjectTemplateSetting): Promise<any> => ApiClient.post(
  '/api/task/label_group_templates',
  (result: ResponsePostTaskProjectTemplateSetting) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskProjectTemplateSetting = async (params: RequestPatchTaskProjectTemplateSetting): Promise<any> => ApiClient.patch(
  `/api/task/label_group_templates/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskProjectTemplateSetting = async (params: RequestDeleteTaskProjectTemplateSetting): Promise<any> => ApiClient.delete(
  `/api/task/label_group_templates/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskApprovalGroup = async (): Promise<any> => ApiClient.get(
  "/api/task/approval_groups",
  (result: ResponseGetTaskApprovalGroup) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskApprovalGroup = async (params: RequestPostTaskApprovalGroup): Promise<any> => ApiClient.post(
  '/api/task/approval_groups',
  (result: ResponsePostTaskApprovalGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskApprovalGroup = async (params: RequestPatchTaskApprovalGroup): Promise<any> => ApiClient.patch(
  `/api/task/approval_groups/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskApprovalGroup = async (params: RequestDeleteTaskApprovalGroup): Promise<any> => ApiClient.delete(
  `/api/task/approval_groups/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskApprovalApplicationList = async (params: RequestGetTaskApprovalApplicationList): Promise<any> => ApiClient.get(
  "/api/task/approval_applications/member_list",
  (result: ResponseGetTaskApprovalApplicationList) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskApprovalApplication = async (params: RequestGetTaskApprovalApplication): Promise<any> => ApiClient.get(
  "/api/task/approval_applications",
  (result: ResponseGetTaskApprovalApplication) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskApprovalApplicationDetail = async (params: RequestGetTaskApprovalApplicationDetail): Promise<any> => ApiClient.get(
  `/api/task/approval_applications/${params.id}`,
  (result: ResponseGetTaskApprovalApplicationDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskApprovalApplication = async (params: RequestPostTaskApprovalApplication): Promise<any> => ApiClient.post(
  '/api/task/approval_applications',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskExcludeGenerateMemberSetting = async (): Promise<any> => ApiClient.get(
  "/api/task/exclude_task_generate_member_settings",
  (result: ResponseGetTaskExcludeGenerateMemberSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskExcludeGenerateMemberSetting = async (params: RequestPostTaskExcludeGenerateMemberSetting): Promise<any> => ApiClient.post(
  '/api/task/exclude_task_generate_member_settings',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskExcludeGenerateMemberSetting = async (params: RequestDeleteTaskExcludeGenerateMemberSetting): Promise<any> => ApiClient.delete(
  `/api/task/exclude_task_generate_member_settings/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelGroupCategory = async (): Promise<any> => ApiClient.get(
  "/api/task/label_group_categories",
  (result: ResponseGetTaskLabelGroupCategory) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelGroupCategoryLabelGroup = async (params: RequestGetTaskLabelGroupCategoryLabelGroup): Promise<any> => ApiClient.get(
  `/api/task/label_group_categories/label_groups`,
  (result: ResponseGetTaskLabelGroupCategoryLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskLabelGroupCategory = async (params: RequestPostTaskLabelGroupCategory): Promise<any> => ApiClient.post(
  '/api/task/label_group_categories',
  (result: ResponsePostTaskLabelGroupCategory) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelGroupCategory = async (params: RequestPatchTaskLabelGroupCategory): Promise<any> => ApiClient.patch(
  `/api/task/label_group_categories/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskLabelGroupCategory = async (params: RequestDeleteTaskLabelGroupCategory): Promise<any> => ApiClient.delete(
  `/api/task/label_group_categories/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroupCategory = async (params: RequestGetTaskReportLabelGroupCategory): Promise<any> => ApiClient.get(
  "/api/task/report/label_group_categories",
  (result: ResponseGetTaskReportLabelGroupCategory) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskReportLabelGroupCategoryDetail = async (params: RequestGetTaskReportLabelGroupCategoryDetail): Promise<any> => ApiClient.get(
  `/api/task/report/label_group_categories/${params.id}`,
  (result: ResponseGetTaskReportLabelGroupCategoryDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskReportLabelGroupCategoryDetailMax = async (params: RequestGetTaskReportLabelGroupCategoryDetailMax): Promise<any> => ApiClient.get(
  `/api/task/report/label_group_categories/${params.label_group_category_id}/max`,
  (result: ResponseGetTaskReportLabelGroupCategoryDetailMax) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskReportLabelGroupCategoryDetailSummary = async (params: RequestGetTaskReportLabelGroupCategoryDetailSummary): Promise<any> => ApiClient.get(
  `/api/task/report/label_group_categories/${params.label_group_category_id}/summary`,
  (result: ResponseGetTaskReportLabelGroupCategoryDetailSummary) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCustomSearchNew = async (): Promise<any> => ApiClient.get(
  "/api/task/custom_search/new",
  (result: ResponseGetTaskCustomSearchNew) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCustomSearch = async (params: RequestGetTaskCustomSearch): Promise<any> => ApiClient.get(
  "/api/task/custom_search",
  (result: ResponseGetTaskCustomSearch) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskGanttChartList = async (): Promise<any> => ApiClient.get(
  '/api/task/gantt_charts',
  (result: ResponseGetTaskGanttChartList) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskGanttChart = async (params: RequestGetTaskGanttChart): Promise<any> => ApiClient.get(
  `/api/task/gantt_charts/${params.id}`,
  (result: ResponseGetTaskGanttChart) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const getTaskGanttChartDetail = async (params: RequestGetTaskGanttChartDetail): Promise<any> => ApiClient.get(
  `/api/task/gantt_chart_detail`,
  (result: ResponseGetTaskGanttChartDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabel = async (params: RequestPatchTaskLabel): Promise<any> => ApiClient.patch(
  `/api/task/labels/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelMember = async (params: RequestPatchTaskLabelMember): Promise<any> => ApiClient.patch(
  `/api/task/labels/${params.label_id}/members/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postTaskExcludeAutoLabelingTask = async (params: RequestPostTaskExcludeAutoLabelingTask): Promise<any> => ApiClient.post(
  '/api/task/exclude_auto_labeling_tasks',
  (result: ResponsePostTaskExcludeAutoLabelingTask) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskExcludeAutoLabelingTask = async (params: RequestDeleteTaskExcludeAutoLabelingTask): Promise<any> => ApiClient.delete(
  `/api/task/exclude_auto_labeling_tasks/${params.id}`,
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const postTaskLabelMasterImport = async (params: RequestPostTaskLabelMasterImport): Promise<any> => ApiClient.post(
  '/api/task/label_master_imports',
  (result: ResponsePostTaskLabelMasterImport) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelGroupOrder = async (): Promise<any> => ApiClient.get(
  '/api/task/label_group_order',
  (result: ResponseGetTaskLabelGroupOrder) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelGroupOrder = async (params: RequestPatchTaskLabelGroupOrder): Promise<any> => ApiClient.patch(
  '/api/task/label_group_order',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLearningScopeSetting = async (): Promise<any> => ApiClient.get(
  '/api/task/learning_scope_setting',
  (result: ResponseGetTaskLearningScopeSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLearningScopeSetting = async (params: RequestPatchTaskLearningScopeSetting): Promise<any> => ApiClient.patch(
  '/api/task/learning_scope_setting',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelingTargetModeSetting = async (): Promise<any> => ApiClient.get(
  '/api/task/labeling_target_mode_settings',
  (result: ResponseGetTaskLabelingTargetModeSetting) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskLabelingTargetModeSetting = async (params: RequestPatchTaskLabelingTargetModeSetting): Promise<any> => ApiClient.patch(
  '/api/task/labeling_target_mode_settings',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCompanyServiceName = async (): Promise<any> => ApiClient.get(
  '/api/setting/company_service_name',
  (result: ResponseGetTaskCompanyServiceName) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskCompanyServiceNameEdit = async (params: RequestGetTaskCompanyServiceNameEdit): Promise<any> => ApiClient.get(
  '/api/setting/company_service_name/edit',
  (result: ResponseGetTaskCompanyServiceNameEdit) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTaskCompanyServiceName = async (params: RequestPatchTaskCompanyServiceName): Promise<any> => ApiClient.patch(
  '/api/setting/company_service_name',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getImportCsv = async (): Promise<any> => ApiClient.getFile(
  '/api/task/label_group_imports',
  (result) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const postTaskLabelGroupImport = async (params: FormData): Promise<any> => ApiClient.postWithMulti(
  '/api/task/label_group_imports',
  (result: ResponsePostTaskLabelGroupImport) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskBulkLabelingNew = async (): Promise<any> => ApiClient.get(
  "/api/task/bulk_labeling/new",
  (result: ResponseGetTaskBulkLabelingNew) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskBulkLabeling = async (params: RequestGetTaskBulkLabeling): Promise<any> => ApiClient.get(
  "/api/task/bulk_labeling",
  (result: ResponseGetTaskBulkLabeling) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const postTaskBulkLabeling = async (params: RequestPostTaskBulkLabeling): Promise<any> => ApiClient.post(
  '/api/task/bulk_labeling',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteTaskBulkLabeling = async (params: RequestDeleteTaskBulkLabeling): Promise<any> => ApiClient.delete(
  `/api/task/bulk_labeling`,
  () => {
    // do nothing
  },
  { data: params },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskNotWorkingRange = async (params: RequestGetTaskNotWorkingRange): Promise<any> => ApiClient.get(
  "/api/task/not_working_range",
  (result: ResponseGetTaskNotWorkingRange) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
export const patchTaskNotWorkingRange = async (params: RequestPatchTaskNotWorkingRange): Promise<any> => ApiClient.patch(
  '/api/task/not_working_range',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskSearchLabelGroup = async (params: RequestGetTaskSearchLabelGroup): Promise<any> => ApiClient.get(
  "/api/task/search_label_groups",
  (result: ResponseGetTaskSearchLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskRecentlyUsedLabelGroup = async (params: RequestGetTaskRecentlyUsedLabelGroup): Promise<any> => ApiClient.get(
  "/api/task/recently_used_label_groups",
  (result: ResponseGetTaskRecentlyUsedLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskLabelGroupSummary = async (params: RequestGetTaskLabelGroupSummary): Promise<any> => ApiClient.get(
  "/api/task/label_group_summaries",
  (result: ResponseGetTaskLabelGroupSummary) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskViewableLabelGroup = async (params: RequestGetTaskViewableLabelGroup): Promise<any> => ApiClient.get(
  "/api/task/viewable_label_groups",
  (result: ResponseGetTaskViewableLabelGroup) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskViewableLabelGroupDetail = async (params: RequestGetTaskViewableLabelGroupDetail): Promise<any> => ApiClient.get(
  `/api/task/viewable_label_groups/${params.id}`,
  (result: ResponseGetTaskViewableLabelGroupDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskViewableLabelGroupMember = async (params: RequestGetTaskViewableLabelGroupMember): Promise<any> => ApiClient.get(
  "/api/task/viewable_label_groups/members",
  (result: ResponseGetTaskViewableLabelGroupMember) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTaskViewableLabelGroupTeam = async (params: RequestGetTaskViewableLabelGroupTeam): Promise<any> => ApiClient.get(
  "/api/task/viewable_label_groups/teams",
  (result: ResponseGetTaskViewableLabelGroupTeam) => result,
  params,
)
